import { ReactNode, useState } from "react";
import styled from "styled-components";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";

const buttonStyle = {
  minWidth: "150px",
  padding: "2px 5px",
};

const tabGroups = [
  {
    key: "users",
    value: "users",
    label: "Relay Users",
  },
  {
    key: "access-requests",
    value: "access-requests",
    label: "Access Requests",
  },
];

const Tabs: React.FC<{
  onTabSelect?: (tab: string) => void;
}> = ({ onTabSelect = () => {} }) => {
  // get current url
  const currentUrl = window.location.pathname;

  const defaultGroup = tabGroups.find((group) =>
    currentUrl.includes(group.key)
  )?.value;

  const [group, setGroup] = useState(defaultGroup || "users");

  const handleChange = (event: any, newGroup: string) => {
    if (newGroup !== null) {
      setGroup(newGroup);
      if (newGroup !== group) {
        onTabSelect(newGroup);
      }
    }
  };

  const control = {
    value: group,
    onChange: handleChange,
    exclusive: true,
  };

  return (
    <div style={{ margin: "0 auto", marginBottom: 15, display: "flex" }}>
      <ToggleButtonGroup size="small" {...control} style={{ margin: "auto" }}>
        {tabGroups.map((group) => (
          <ToggleButton
            value={group.value}
            key={group.key}
            size="small"
            disableRipple={true}
            style={buttonStyle}
          >
            {group.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;
`;

export const UserManagement: React.FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <StyledContainer>
      <Tabs onTabSelect={navigate} />
      {children}
      <Outlet />
    </StyledContainer>
  );
};
